import { FormattedRowParams } from '@qrios/frontend-library';

import queryTypesMapper from '../../../../constants/queryTypesToString';

export const queryTypesFormatter = ({ value }: FormattedRowParams) => queryTypesMapper(value as string);
